import React from "react";
import styles from "./charity.module.scss";
export const Charity = () => {
    return (
        <div className={styles.charity}>
            {/* <div className="container">
        <div className={styles.make}>
          <h2>MAKE YOUR OWN DAY OF CHARITY</h2>
          <p>
            Add goodwill to your special occasions by spreading joy among those
            who need your care and support the most.
          </p>
        </div>
        <div className={styles.choose}>
          <div>
            <p>CHOOSE AN OCCASION</p>
          </div>
          <div>
            <div>
              <a
                href="https://docs.google.com/forms/d/e/1FAIpQLScjc6uaaQO15us5v00RfzGLWcbLhQ8WP5zxMwGe-BJkoCOSDg/viewform"
                target="_black"
              >
                <img src="celebration.png" alt="" />
                <p>Celebration</p>
              </a>
            </div>
            <div>
              <img src="inHonorof.png" alt="" />
              <p>In honour of</p>
            </div>
            <div>
              <img src="inMemoryof.png" alt="" />
              <p>In memory of</p>
            </div>
          </div>
        </div>
      </div> */}
        </div>
    );
};
